<template>
  <div class="dialog-overlay">
    <div class="dialog-content ai-dialog">
      <div class="dialog-header">
        <h2>AI Course Creator</h2>
        <button @click="$emit('close')" class="close-button">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>
      <!-- AI Course Creator Dialog content goes here -->
      <div class="dialog-body">
        <p>This feature is coming soon!</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIAssistantDialog',
  emits: ['close']
};
</script> 